.groupContainer {
    border-radius: 10px !important;
}

.menuList {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    // Drop the first item so its background lines up with the content card's top
    // on the right; the toggle above stays anchored to the header.
    margin-top: 28px;
    // Figma spec (Section container): Gap 6px between each stacked element
    // (icon, divider, icon …). Height stays Hug — it grows with the number of
    // icons — so the gap is the source of truth, not the total height.
    gap: 6px;

    // No divider after the last item.
    > div:last-child .horizLine {
        display: none;
    }
}

// Each item wraps an icon plus its divider; keep the same 6px rhythm inside so
// every element (icon → divider → icon …) is evenly spaced by 6px.
.menuItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.horizLine {
    // Figma divider: height 0, so it must add no height to the flex flow. A
    // border/height of 1px would occupy a real pixel and accumulate a 1px drift
    // per item; a box-shadow paints the 1px line without consuming layout, so
    // every item stays exactly 44px and the 6px rhythm holds all the way down.
    width: 32px;
    height: 0;
    flex-shrink: 0;
    box-shadow: 0 0 0 0.5px #eaecf0;
    transition: width 0.2s ease;
}

.horizLineExpanded {
    width: 177px;
}

// Renders SVG nav icons as a mask so their colour is driven by CSS (exact
// #475467) instead of each SVG's baked-in stroke.
.iconMask {
    display: inline-block;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    background-color: #475467;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
}

.groupLink {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 8px;
    width: 32px;
    height: 32px;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
    border-radius: 8px;
    font-weight: 400;
    font-size: 15px;
    line-height: 16px;
    font-family: Hanken Grotesk;
    color: #475467 !important;
    transition: width 0.2s ease;

    &:hover {
        color: #475467 !important;
        background-color: #e2edff;
    }
}

.groupLinkExpanded {
    width: 177px;
}

.groupLinkSelected {
    font-weight: 600 !important;
    background-color: #f1efe9;
}

.label {
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.15s ease;
}

.labelExpanded {
    opacity: 1;
}

.toggleRow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.toggleRowExpanded {
    justify-content: flex-end;
}

.toggleButton {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 32px;
    height: 22px;
    padding: 3px 4px;
    box-sizing: border-box;

    background-color: transparent;
    border-radius: 4px;
    border: 1px solid #e4e7ec;
    color: #727b8c;
    cursor: pointer;
    transition:
        background-color 0.15s ease,
        color 0.15s ease;

    &:hover {
        background-color: #e2edff;
        color: black;
    }

    &:focus-visible {
        outline: 2px solid #2f6bff;
        outline-offset: 2px;
    }

    i {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 14px;
        height: 12px;
        font-size: 14px;
        line-height: 12px;
    }
}

// Expanded: no outline box — just the bare icon (per design).
.toggleButtonExpanded {
    border-color: transparent;
    background-color: transparent;
}

.navTooltip {
    // Sit above every other stacking context in the deal view (the offcanvas
    // rail is at 100000; loading overlays reach 10000000).
    z-index: 2147483647 !important;
    opacity: 1 !important;
}
